import React from "react";
import ReactDOM from "react-dom";
import Chart from "react-google-charts";

const data = [
  ["Element", "Density", { role: "style" }],
  ["JAN", 8.94, "#00609D"], // RGB value
  ["Feb", 10.49, "#00609D"], // English color name
  ["March", 19.3, "#00609D"],
  ["April", 21.45, "color: #00609D"],// CSS-style declaration
  ["May", 21.45, "color: #00609D"], // CSS-style declaration

];
export default ()=> {
    return (
      <div>
        <div className="col-md-6 rounded">
          <h5 className="p-2">Impressions</h5>
        <Chart
          chartType="ColumnChart"
          width="400px"
          // height="400px"
          data={data}
        />
        </div>
      </div>
    );
}
